/* Card colour swatches: flip the card image instead of navigating. */
(function () {
  if (window.__mkCardSibs) return;
  window.__mkCardSibs = true;

  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('.mk-csc__item[data-mk-sw]');
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();

    var card = sw.closest('.t4s-product');
    if (!card) return;

    var img = card.querySelector('.t4s-product-main-img');
    var src = sw.getAttribute('data-img');
    if (img && src) {
      img.removeAttribute('srcset');
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-widths');
      img.setAttribute('src', src);
      img.classList.add('lazyloadt4sed');
    }

    var url = sw.getAttribute('data-url');
    var pid = sw.getAttribute('data-pid');
    var title = sw.getAttribute('data-title');

    if (url) {
      card.querySelectorAll('a[href]').forEach(function (a) {
        if (a.hasAttribute('data-mk-sw')) return;
        a.setAttribute('href', url);
      });
    }
    if (pid) {
      card.querySelectorAll('[data-action-quickview],[data-action-quickshop],[data-action-atc]').forEach(function (b) {
        b.setAttribute('data-id', pid);
      });
    }
    if (title) {
      var t = card.querySelector('.t4s-product-title a');
      if (t) t.textContent = title;
    }
    card.querySelectorAll('.mk-csc__item').forEach(function (x) { x.classList.remove('is--current'); });
    sw.classList.add('is--current');
  }, true);
})();
